var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tls-legal-terms-website" }, [
    _c("header", { staticClass: "tls-simple-banner" }, [
      _c("div", { staticClass: "tls-home-text-group" }, [
        _c("h1", { staticClass: "tls-heading-1" }, [
          _vm._v(
            _vm._s(_vm._.get(_vm.legalTermsWebsiteCmsData, "banner_title"))
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tls-simple-text -color-white -size-20" }, [
          _vm._v(
            _vm._s(_vm._.get(_vm.legalTermsWebsiteCmsData, "banner_sub_title"))
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tls-static-content tls-legal-terms-website-content" },
      [
        _c("div", { staticClass: "tls-large-card-info" }, [
          _c("div", { staticClass: "tls-card-lg" }, [
            _c("div", { staticClass: "tls-simple-text -size-16" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm._.get(_vm.legalTermsWebsiteCmsData, "card_title"))
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tls-legal-terms-website-action",
            attrs: { id: "top" }
          },
          [
            _vm._.get(_vm.legalTermsWebsiteCmsData, "action_title") &&
            _vm._.get(_vm.legalTermsWebsiteCmsData, "action_button")
              ? _c(
                  "div",
                  { staticClass: "tls-legal-terms-website-action--heading" },
                  [
                    _c(
                      "div",
                      { staticClass: "tls-legal-terms-website-action--slot" },
                      [
                        _c("h2", { staticClass: "tls-heading-2" }, [
                          _vm._v(
                            _vm._s(
                              _vm._.get(
                                _vm.legalTermsWebsiteCmsData,
                                "action_title"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("h2", { staticClass: "tls-heading-2" }, [
                          _vm._v(
                            _vm._s(
                              _vm._.get(
                                _vm.legalTermsWebsiteCmsData,
                                "action_sub_title"
                              )
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tls-legal-terms-website-action--slot" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "tls-button-primary",
                            on: { click: _vm.redirectAddValueUrl }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._.get(
                                    _vm.legalTermsWebsiteCmsData,
                                    "action_button"
                                  )
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tls-legal-terms-website-action--title" },
              [
                _c("div", { staticClass: "tls-simple-text -size-16" }, [
                  _vm._v(
                    _vm._s(
                      _vm._.get(_vm.legalTermsWebsiteCmsData, "action_text")
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tls-legal-terms-website-action--slot" }, [
              _c("h2", { staticClass: "tls-heading-2" }, [
                _vm._v(
                  _vm._s(
                    _vm._.get(_vm.legalTermsWebsiteCmsData, "action_slot_title")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tls-legal-terms-website-action--slot" }, [
              _c(
                "div",
                { staticClass: "tls-legal-terms-website-action-text" },
                [
                  _c(
                    "ul",
                    { staticClass: "tls-link-list" },
                    _vm._l(_vm._.sortBy(_vm.contentSlotData, "sort"), function(
                      list_item,
                      index
                    ) {
                      return _c("li", { staticClass: "tls-link-list--slot" }, [
                        _c(
                          "a",
                          {
                            staticClass: "tls-link",
                            attrs: {
                              href:
                                _vm._.get(_vm.path, "path") +
                                "#tls-terms-website-" +
                                index.toString()
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._.get(list_item, "slot_title_translation")
                              )
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "dompurify-html",
                        rawName: "v-dompurify-html",
                        value: _vm._.get(
                          _vm.legalTermsWebsiteCmsData,
                          "action_slot_text"
                        ),
                        expression:
                          "_.get(legalTermsWebsiteCmsData, 'action_slot_text')"
                      }
                    ],
                    staticClass: "tls-simple-text -size-16"
                  })
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tls-legal-terms-website-info" },
          [
            _c("div", {
              directives: [
                {
                  name: "dompurify-html",
                  rawName: "v-dompurify-html",
                  value: _vm._.get(
                    _vm.legalTermsWebsiteCmsData,
                    "content_head"
                  ),
                  expression: "_.get(legalTermsWebsiteCmsData, 'content_head')"
                }
              ],
              staticClass: "tls-simple-text -size-16"
            }),
            _vm._v(" "),
            _vm._l(_vm._.sortBy(_vm.contentSlotData, "sort"), function(
              privacy_item,
              index
            ) {
              return _c(
                "div",
                { staticClass: "tls-legal-terms-website-info--content" },
                [
                  _c(
                    "h2",
                    {
                      staticClass: "tls-heading-2 anchor",
                      attrs: { id: "tls-terms-website-" + index.toString() }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._.get(privacy_item, "slot_title_translation")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._.get(privacy_item, "short_desc")
                    ? _c("div", {
                        directives: [
                          {
                            name: "dompurify-html",
                            rawName: "v-dompurify-html",
                            value: _vm._.get(privacy_item, "short_desc"),
                            expression: "_.get(privacy_item, 'short_desc')"
                          }
                        ],
                        staticClass: "tls-simple-text -size-16"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._.get(privacy_item, "table_title") !== "Undefined" &&
                  _vm._.get(privacy_item, "table_title")
                    ? _c(
                        "div",
                        { staticClass: "tls-legal-terms-website-table" },
                        [
                          _c("h3", { staticClass: "tls-heading-3" }, [
                            _vm._v(
                              _vm._s(_vm._.get(privacy_item, "table_title"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tls-table-card-info" }, [
                            _c("div", { staticClass: "tls-card-lg" }, [
                              _c("table", [
                                _c(
                                  "tbody",
                                  _vm._l(
                                    _vm._.get(privacy_item, "table_content"),
                                    function(table_item) {
                                      return _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "tls-table-head" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._.get(table_item, "name")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "tls-table-cell" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._.get(table_item, "purpose")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "tls-table-cell" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._.get(
                                                  table_item,
                                                  "description"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "tls-table-cell" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._.get(
                                                  table_item,
                                                  "storage_period"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    }
                                  ),
                                  0
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "dompurify-html",
                        rawName: "v-dompurify-html",
                        value: _vm._.get(privacy_item, "long_desc"),
                        expression: "_.get(privacy_item, 'long_desc')"
                      }
                    ],
                    staticClass: "tls-simple-text -size-16"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tls-tab-content-paragraph" }, [
                    _c("i", { staticClass: "fa fa-chevron-up" }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "tls-link",
                        attrs: { href: _vm._.get(_vm.path, "path") + "#top" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm._.get(_vm.keywords, "back_to_the_top"))
                        )
                      ]
                    )
                  ])
                ]
              )
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "tls-large-terms-website-card-info--decoration" },
      [
        _c("div", { staticClass: "tls-decoration-vertical-lines -blue" }, [
          _c("div", { staticClass: "tls-line1" }),
          _vm._v(" "),
          _c("div", { staticClass: "tls-line2" })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }